module.exports = __webpack_public_path__ + "static/media/bg-about-us@2x.83ab7316.jpg";